<template>
    <div style="height: 100%">
        <!-- 模式切换：入住申请记录（原列表模式，保持不变）/ 日历图（新增）；仅作切换器，内容区用 v-show 控制 -->
        <div class="dc-tabs-wrap">
            <el-tabs v-model="activeTab" @tab-click="onTabClick">
                <el-tab-pane label="入住申请记录" name="list"></el-tab-pane>
                <el-tab-pane label="日历图" name="calendar"></el-tab-pane>
            </el-tabs>
        </div>
        <!-- 列表模式查询栏：v-if 彻底销毁——日历模式下绝不渲染（用户反馈日历模式不需要查询条件） -->
        <div style="display: flex; width: 100%" v-if="activeTab === 'list'">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.ahaUserName" style="width: 120px;" size="mini" placeholder="姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.ahaUserDepartment" style="width: 120px;" size="mini" placeholder="部门"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.ahaStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="申请中" :value="1" key="1"></el-option>
                        <el-option label="同意" :value="2" key="2"></el-option>
                        <el-option label="拒绝" :value="3" key="3"></el-option>
                        <el-option label="已撤销" :value="4" key="4"></el-option>
                        <el-option label="已退房" :value="5" key="5"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增入住申请</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-show="activeTab === 'list'">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ahaId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 日历图模式（新增）：宿舍入住日历，独立 dc- 前缀样式，不影响列表模式；悬浮记录条弹出详情+操作 -->
            <div class="dc-calendar" v-show="activeTab === 'calendar'">
                <!-- 工具栏：上一月 / 月份选择器（禁未来）/ 下一月 / 回到今天 -->
                <div class="dc-toolbar">
                    <div class="dc-toolbar-left">
                        <el-button size="small" icon="el-icon-arrow-left" @click="prevMonth">上一月</el-button>
                        <el-date-picker v-model="calMonthDate" type="month" size="small" :clearable="false"
                            :picker-options="calPickerOptions" format="yyyy 年 MM 月" placeholder="选择月份"
                            style="width: 150px" @change="onMonthPick"></el-date-picker>
                        <!-- 未来月份也可查看（用户要求：未来时段的入住/申请也能在日历上看到） -->
                        <el-button size="small" @click="nextMonth">下一月<i
                                class="el-icon-arrow-right el-icon--right"></i></el-button>
                        <el-button size="small" type="primary" plain @click="goToday">回到今天</el-button>
                    </div>
                    <!-- 年月已由月份选择器展示，不再放大标题，避免与右侧统计在窄屏下挤压重叠 -->
                    <div class="dc-toolbar-count">{{ calYear }}年{{ calMonth }}月 · 在住 / 申请中共 {{ calendarRecords.length }} 条</div>
                </div>
                <!-- 图例：宿舍颜色对照（色相区分宿舍、明度区分人）+ 状态样式说明 -->
                <div class="dc-legend">
                    <div class="dc-legend-dorms">
                        <span v-for="d in dormLegend" :key="d.name" class="dc-legend-item">
                            <span class="dc-legend-dot" :style="{ background: d.color }"></span>{{ d.name }}
                        </span>
                    </div>
                    <div class="dc-legend-status">
                        <span class="dc-legend-chip dc-legend-chip--ok">已同意</span>
                        <span class="dc-legend-chip dc-legend-chip--pending">申请中</span>
                        <span class="dc-legend-tip">「入」入住当天 ·「退」预计退宿当天</span>
                    </div>
                </div>
                <!-- 周表头：周一作为每周第一天（国内习惯） -->
                <div class="dc-grid-head">
                    <div v-for="w in weekLabels" :key="w" class="dc-head-cell"
                        :class="{ 'dc-head-cell--weekend': w === '六' || w === '日' }">{{ w }}</div>
                </div>
                <!-- 月历网格：含上下月补位日期（置灰），每格展示当天处于入住区间的记录 -->
                <div class="dc-grid-body" v-loading="calLoading">
                    <div v-for="(row, rowIndex) in calendarRows" :key="'row' + rowIndex" class="dc-grid-row">
                        <div v-for="cell in row" :key="cell.key" class="dc-cell"
                            :class="{ 'dc-cell--other': !cell.inMonth, 'dc-cell--today': cell.isToday }">
                            <div class="dc-cell-date">
                                <span class="dc-daynum"
                                    :class="{ 'is-today': cell.isToday, 'is-weekend': cell.isWeekend }">{{ cell.day }}</span>
                            </div>
                            <!-- 记录条区：全量渲染，超出格子高度时在格子内上下滑动查看（用户反馈要求滑动展示） -->
                            <!-- 悬浮记录条弹出详情与操作（审核 / 修改预计退房时间 / 系统退房，规则与列表一致） -->
                            <div class="dc-cell-items">
                                <el-popover v-for="item in cell.items" :key="item.rec.ahaId" placement="top-start"
                                    trigger="hover" width="300" :open-delay="120" append-to-body>
                                    <div class="dc-chip" :style="chipStyle(item)" slot="reference">
                                        <span v-if="item.isIn" class="dc-badge dc-badge--in">入</span>
                                        <!-- 显示「宿舍名·人名」，超宽自动省略，悬浮卡片可看全称 -->
                                        <span class="dc-chip-name">{{ item.rec.ahbName || '未分配' }}·{{ item.rec.ahaUserName }}</span>
                                        <span v-if="item.isOut" class="dc-badge dc-badge--out">退</span>
                                    </div>
                                    <div class="dc-pop">
                                        <div class="dc-pop-title">
                                            <span class="dc-legend-dot" :style="{ background: dotColor(item.rec) }"></span>
                                            {{ item.rec.ahaUserName }}
                                            <el-tag size="mini" :type="item.rec.ahaStatus == 1 ? 'warning' : 'success'">
                                                {{ item.rec.ahaStatus == 1 ? '申请中' : '入住中' }}</el-tag>
                                        </div>
                                        <div class="dc-pop-row">部门：{{ item.rec.ahaUserDepartment || '-' }}</div>
                                        <div class="dc-pop-row">房间：
                                            <el-button v-if="item.rec.ahbName" type="text" size="mini"
                                                style="color: green" @click="handleRoomDetail(item.rec)">{{ item.rec.ahbName
                                                }}</el-button>
                                            <span v-else>未分配</span>
                                        </div>
                                        <div class="dc-pop-row">入住时间：{{ item.rec.ahaUserDateCheckIn || '-' }}</div>
                                        <div class="dc-pop-row">预计退房：{{ item.rec.ahaUserDateCheckOut || '未定（持续入住）' }}
                                        </div>
                                        <div class="dc-pop-actions">
                                            <el-button v-if="item.rec.ahaStatus == 1" type="primary" size="mini"
                                                @click="handleCheck(item.rec)">审核</el-button>
                                            <el-button v-if="item.rec.ahaStatus == 2" size="mini"
                                                @click="handleEdit(item.rec)">修改预计退房时间</el-button>
                                            <el-button v-if="item.rec.ahaStatus == 2" type="danger" size="mini"
                                                @click="handleCheckOut(item.rec)">系统退房</el-button>
                                        </div>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="calEmpty" class="dc-empty">本月暂无入住 / 申请记录</div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑预计退房时间' : '新增入住申请'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                            <el-form-item label="预计退房时间" prop="ahaUserDateCheckOut">
                                <el-date-picker v-model="form.ahaUserDateCheckOut" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="状态" :visible.sync="dialogStatus" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formCheck" :model="formCheck" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="是否同意" prop="ahaStatus">
                                <el-radio-group v-model="formCheck.ahaStatus">
                                    <el-radio label="2">同意</el-radio>
                                    <el-radio label="3">拒绝</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="宿舍房间" prop="ahbId" v-if="formCheck.ahaStatus == 2">
                                <el-select v-model="formCheck.ahbId" filterable placeholder="请选择">
                                    <el-option v-for="item in statusAll || []" :label="item.ahbName" :value="item.ahbId"
                                        :key="item.ahbId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="审核备注" prop="checkDes">
                                <el-input v-model="formCheck.checkDes" style="width: 100%;" placeholder="请输入"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="closeStatus">取 消</el-button>
                            <el-button type="primary" @click="sureStatus">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <el-dialog title="退房申请" :visible.sync="isCheckOut" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formRefCheck" :model="form" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="1. 状态" prop="ahcoStatus">
                                <el-radio-group v-model="form.ahcoStatus">
                                    <el-radio label="2">按要求退房</el-radio>
                                    <el-radio label="3">未按要求退房</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="2. 实际退房时间" prop="ahcoDateCheckOut">
                                <el-date-picker v-model="form.ahcoDateCheckOut" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="3. 用过床单被罩枕套" prop="ahcoTwo">
                                <el-select v-model="form.ahcoTwo" placeholder="请选择" style="width: 100%;">
                                    <el-option label="已机洗并晾晒" value="已机洗并晾晒"></el-option>
                                    <el-option label="未清洗已叠好放床尾" value="未清洗已叠好放床尾"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="4.  用过床单被罩枕套拍照" prop="ahcoTwoSign">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="5. 钥匙归还" prop="ahcoThree">
                                <el-select v-model="form.ahcoThree" placeholder="请选择" style="width: 100%;">
                                    <el-option label="密码锁无需" value="密码锁无需"></el-option>
                                    <el-option label="已归还" value="已归还"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="6.  钥匙归还拍照" prop="ahcoThreeSign">
                                <my-upload ref="Imgupload2" @fileChange="fileChange2" :filearr="fileList2" :limit="10"
                                    @removeAfter="removeAfter2" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="7. 宿舍内原有生活备用品是否需要补充" prop="ahcoFour">
                                <el-select v-model="form.ahcoFour" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="8. 补充描述" prop="ahcoFourDes">
                                <el-input v-model="form.ahcoFourDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="9. 个人物品是否都清理干净，房间内无垃圾？" prop="ahcoFive">
                                <el-select v-model="form.ahcoFive" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="10.  房间拍照" prop="ahcoFiveSign">
                                <my-upload ref="Imgupload3" @fileChange="fileChange3" :filearr="fileList3" :limit="10"
                                    @removeAfter="removeAfter3" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="11. 门锁/空调/窗户 是否已检查关好" prop="ahcoSix">
                                <el-select v-model="form.ahcoSix" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="12.  门锁/空调/窗户 拍照" prop="ahcoSixSign">
                                <my-upload ref="Imgupload4" @fileChange="fileChange4" :filearr="fileList4" :limit="10"
                                    @removeAfter="removeAfter4" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="13. 审核备注" prop="checkDes">
                                <el-input v-model="form.checkDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="closeCheckOut">取 消</el-button>
                            <el-button type="primary" @click="sureCheckOut">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>

            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/fireequipment.xlsx', '入住申请模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
            <!-- 房间详情 -->
            <el-dialog title="房间详情" :visible.sync="isRoom" width="70%" style="margin-left: 200px;">
                <div>
                    <ve-table :columns="columnsRoom" :table-data="RoomDetail" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="RoomDetail.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjHostelBaseList, updateAjHostelApplyCheck, uploadImportAjAssetsFireEquipment, addAjHostelCheckOutSystem,
    getAjHostelApplyList, addAjAssetsFireEquipment, updateAjHostelApplyDateCheckOut, deleteAjAssetsFireEquipment, uploadAjAssetsFireEquipment
} from "../../api/api";

// ==================== 日历图模式：常量与工具 ====================
// 调色板：12 个色相（HSL），宿舍按首次出现顺序对长度取模分配 → 色相区分宿舍
const CAL_PALETTE = [210, 0, 145, 30, 270, 180, 330, 90, 45, 240, 15, 300];
// 色阶：同一宿舍内申请人按首次出现顺序对长度取模分配 → 明度区分人（light → dark）
const CAL_SHADES = [66, 57, 48, 39];
// 两位数字补零（不用 padStart，兼容更老内核）
function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
}
// Date → 'yyyy-MM-dd'；日历统一用日期字符串（前 10 位）做字典序比较，
// 避免直接 new Date('yyyy-MM-dd HH:mm:ss') 在 Safari 下返回 NaN 的兼容问题
function fmtDate(d) {
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
}
export default {
    name: "",
    components: {},
    data() {
        return {
            isCheckOut: false,
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],

            isRoom: false,
            RoomDetail: [],
            formCheck: {},
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'ahaId',
            dialog: false,
            edit: false,
            form: {
                ahcoTwoSign:[],
                ahcoThreeSign:[],
                ahcoFiveSign:[],
                ahcoSixSign:[],
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aafeNums",
                    key: "aafeNums",
                    title: "灭火器编号",
                    align: "center",
                },
                {
                    field: "equipmentName",
                    key: "equipmentName",
                    title: "设备名称",
                    align: "center",
                },
                {
                    field: "storageLocation",
                    key: "storageLocation",
                    title: "存放位置",
                    align: "center",
                },
                {
                    field: "purchaseDate",
                    key: "purchaseDate",
                    title: "购买日期",
                    align: "center",
                },
                {
                    field: "netWeight",
                    key: "netWeight",
                    title: "净含量",
                    align: "center",
                    edit: true,
                },
                {
                    field: "modelC",
                    key: "modelC",
                    title: "3C规格型号",
                    align: "center",
                    edit: true,
                },
                {
                    field: "cccCertificateNumber",
                    key: "cccCertificateNumber",
                    title: "ccc证书编号",
                    align: "center",
                },
                {
                    field: "manufacturer",
                    key: "manufacturer",
                    title: "制造厂家",
                    align: "center",
                },
                {
                    field: "hasLabel",
                    key: "hasLabel",
                    title: "是否有标签",
                    align: "center",
                },
                {
                    field: "hasExpired",
                    key: "hasExpired",
                    title: "是否过期",
                    align: "center",
                },
                {
                    field: "personInCharge",
                    key: "personInCharge",
                    title: "负责人",
                    align: "center",
                },
                {
                    field: "expectedExpiryDate",
                    key: "expectedExpiryDate",
                    title: "预计到期时间",
                    align: "center",
                },
                {
                    field: "remarks",
                    key: "remarks",
                    title: "备注",
                    align: "center",
                },
            ],
            columnsRoom: [{
                field: "ahbName",
                key: "ahbName",
                title: "房间名称",
                align: "center",
            },
            {
                field: "ahbAddress",
                key: "ahbAddress",
                title: "地址",
                align: "center",
            },
            {
                field: "ahbStructure",
                key: "ahbStructure",
                title: "居室布局",
                align: "center",
            },
            {
                field: "ahbPw",
                key: "ahbPw",
                title: "门锁密码",
                align: "center",
            },
            {
                field: "ahbWifiAccount",
                key: "ahbWifiAccount",
                title: "wifi账号",
                align: "center",
                edit: true,
            },
            {
                field: "ahbWifiPw",
                key: "ahbWifiPw",
                title: "wifi密码",
                align: "center",
                edit: true,
            },
            {
                field: "ahbDailyNecessities",
                key: "ahbDailyNecessities",
                title: "现存生活用品",
                align: "center",
            },
            {
                field: "ahbRoomsNum",
                key: "ahbRoomsNum",
                title: "房间数",
                align: "center",
            },
            {
                field: "ahbReminds",
                key: "ahbReminds",
                title: "提醒",
                align: "center",
            },],
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ahaUserName",
                    key: "ahaUserName",
                    title: "申请人",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaUserDepartment",
                    key: "ahaUserDepartment",
                    title: "申请人部门",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaUserDateCheckIn",
                    key: "ahaUserDateCheckIn",
                    title: "入住时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaUserDateCheckOut",
                    key: "ahaUserDateCheckOut",
                    title: "预计退房时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaUserPet",
                    key: "ahaUserPet",
                    title: "是否对猫狗过敏",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaSign",
                    key: "ahaSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaSign ? <el-image ref="scrImg" id="scrimg" src={row.ahaSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.ahaSign]}></el-image> : <span></span>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "ahbName",
                    key: "ahbName",
                    title: "入住房间",
                    align: "center",
                    width: 180,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahbName ? <el-button
                                        size="mini" type="text" style="color:green" on-click={() => this.handleRoomDetail(row)} > {row.ahbName} </el-button> : <span></span>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "checkDes",
                    key: "checkDes",
                    title: "审核备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaStatus",
                    key: "ahaStatus",
                    title: "状态",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaStatus == 1 ? <el-tag size="mini">申请中</el-tag> : row.ahaStatus == 2 ? <el-tag type="success" size="mini">入住中</el-tag>
                                        : row.ahaStatus == 3 ? <el-tag type="danger" size="mini">拒绝</el-tag> : row.ahaStatus == 4 ? <el-tag type="danger" size="mini">已撤销</el-tag>
                                            : <el-tag type="success" size="mini">已退房</el-tag>
                                }
                                {
                                    row.ahaStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.handleCheck(row)} > 审核 </el-button> : <span></span>
                                }

                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        修改预计退房时间
                                    </el-button> : ''
                                }
                                {
                                    row.ahaStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color:red"
                                        on-click={() => this.handleCheckOut(row)}
                                    >
                                        系统退房
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 20,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

            // ===== 日历图模式 =====
            activeTab: 'list',        // 当前模式：list=入住申请记录列表（默认，原界面不变）；calendar=日历图
            calMonthDate: new Date(), // 日历当前展示月份（只取年月）
            calendarRecords: [],      // 日历数据：申请中(ahaStatus=1) + 已同意(ahaStatus=2) 全量合并
            calendarLoaded: false,    // 首次切到日历时才请求，之后用缓存；操作成功后强制刷新
            calLoading: false,        // 日历数据加载状态
            weekLabels: ['一', '二', '三', '四', '五', '六', '日'], // 周一为每周第一天
            calPickerOptions: {
                // 不禁用任何月份：历史与未来均可查看（未来时段的入住/申请记录也能在日历上看到）
                disabledDate() {
                    return false;
                }
            },
        };
    },
    computed: {
        // 当前展示月份的年份 / 月份（1-12）
        calYear() {
            return this.calMonthDate.getFullYear();
        },
        calMonth() {
            return this.calMonthDate.getMonth() + 1;
        },
        // 当前展示月的月末日期串：无预计退房时间的记录视为持续入住，仅展示到该月末
        calMonthEndStr() {
            return fmtDate(new Date(this.calYear, this.calMonth, 0));
        },
        // 颜色映射（computed 预计算，渲染时只查表）：ahaId → { style: 记录条样式, dotColor: 圆点色 }
        // 分配算法两层 + 状态一层：
        // ① 宿舍（ahbName 为空归「未分配」）按首次出现顺序对调色板取模 → 色相区分宿舍
        // ② 同一宿舍内申请人按首次出现顺序对色阶取模 → 明度区分人
        // ③ 状态决定填充：已同意(2) 实心胶囊；申请中(1) 半透明斜纹 + 虚线边框，一眼可辨
        recordVisualMap() {
            const dormIdx = {};         // 宿舍名 → 首次出现序号
            const personIdx = {};       // 「宿舍名|人名」→ 宿舍内首次出现序号
            const dormPersonCount = {}; // 宿舍名 → 已出现人数
            const map = {};
            this.calendarRecords.forEach(rec => {
                const dorm = rec.ahbName || '未分配';
                if (!(dorm in dormIdx)) dormIdx[dorm] = Object.keys(dormIdx).length;
                const pk = dorm + '|' + rec.ahaUserName;
                if (!(pk in personIdx)) {
                    personIdx[pk] = dormPersonCount[dorm] || 0;
                    dormPersonCount[dorm] = (dormPersonCount[dorm] || 0) + 1;
                }
                const h = CAL_PALETTE[dormIdx[dorm] % CAL_PALETTE.length];
                const l = CAL_SHADES[personIdx[pk] % CAL_SHADES.length];
                const solid = 'hsl(' + h + ', 60%, ' + l + '%)';
                map[rec.ahaId] = {
                    dotColor: solid,
                    style: rec.ahaStatus == 2 ? {
                        // 已同意（入住中）：实心，亮底配深字、暗底配白字
                        background: solid,
                        color: l >= 56 ? '#303133' : '#fff',
                    } : {
                        // 申请中：半透明斜纹 + 虚线边框，与实心形成明显视觉差异
                        background: 'repeating-linear-gradient(45deg, hsla(' + h + ',60%,' + l + '%,0.15) 0px, hsla(' + h + ',60%,' + l + '%,0.15) 5px, hsla(' + h + ',60%,' + l + '%,0.4) 5px, hsla(' + h + ',60%,' + l + '%,0.4) 10px)',
                        border: '1px dashed ' + solid,
                        color: 'hsl(' + h + ', 50%, ' + Math.max(l - 30, 22) + '%)',
                    },
                };
            });
            return map;
        },
        // 图例数据：宿舍名 + 代表色（取该宿舍首个出现记录的颜色），按首次出现顺序
        dormLegend() {
            const order = [];
            const colorOf = {};
            this.calendarRecords.forEach(rec => {
                const dorm = rec.ahbName || '未分配';
                if (!(dorm in colorOf)) {
                    const v = this.recordVisualMap[rec.ahaId];
                    colorOf[dorm] = v ? v.dotColor : '#909399';
                    order.push(dorm);
                }
            });
            return order.map(name => ({ name: name, color: colorOf[name] }));
        },
        // 月历网格：周一为首列，含上下月补位日期（置灰），行数为当月实际周数（5~6 行）
        calendarCells() {
            const y = this.calYear;
            const m = this.calMonth;
            const first = new Date(y, m - 1, 1);
            // getDay(): 0=周日；(getDay()+6)%7 得到周一首列网格下当月 1 号的偏移格数
            const offset = (first.getDay() + 6) % 7;
            const daysInMonth = new Date(y, m, 0).getDate();
            const weeks = Math.ceil((offset + daysInMonth) / 7);
            const todayStr = fmtDate(new Date());
            const cells = [];
            for (let i = 0; i < weeks * 7; i++) {
                // 从当月第一周的周一开始逐格推进日期
                const d = new Date(y, m - 1, 1 - offset + i);
                const dateStr = fmtDate(d);
                // 区间过滤：入住日 <= 当天 <= 预计退房日（取日期字符串前 10 位比较，忽略时分秒）
                const items = [];
                this.calendarRecords.forEach(rec => {
                    const ci = (rec.ahaUserDateCheckIn || '').slice(0, 10);
                    if (!ci || dateStr < ci) return; // 无入住时间的记录不展示
                    const co = (rec.ahaUserDateCheckOut || '').slice(0, 10);
                    if (co) {
                        if (dateStr > co) return;
                    } else if (dateStr > this.calMonthEndStr) {
                        return; // 无预计退房：视为持续入住，只展示到当前展示月月末
                    }
                    items.push({
                        rec: rec,
                        isIn: dateStr === ci,            // 入住当天 →「入」角标
                        isOut: !!co && dateStr === co,   // 预计退宿当天 →「退」角标
                    });
                });
                cells.push({
                    key: dateStr,
                    dateStr: dateStr,
                    day: d.getDate(),
                    inMonth: d.getMonth() === m - 1,
                    isToday: dateStr === todayStr,
                    isWeekend: i % 7 >= 5,
                    items: items, // 全量渲染，超出格子高度时由 .dc-cell-items 在格内滚动
                });
            }
            return cells;
        },
        // 网格按 7 格一行分组（flex 布局实现，不用 CSS grid，兼容老内核）
        calendarRows() {
            const rows = [];
            const cells = this.calendarCells;
            for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));
            return rows;
        },
        // 空态：数据已加载且整月无任何记录
        calEmpty() {
            return this.calendarLoaded && this.calendarCells.every(c => c.items.length === 0);
        },
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        closeCheckOut() {
            this.isCheckOut = false;
            this.$refs['formRefCheck'].resetFields();
            this.form = {}
            this.fileList = []
            this.fileList2 = []
            this.fileList3 = []
            this.fileList4 = []
        },
        sureCheckOut() {
            var that = this;
            this.$confirm("是否确定要退房吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(that.form))
                    newForm.ahcoTwoSign = newForm.ahcoTwoSign && newForm.ahcoTwoSign.length > 0 ? JSON.stringify(newForm.ahcoTwoSign) : '';
                    newForm.ahcoThreeSign = newForm.ahcoThreeSign && newForm.ahcoThreeSign.length > 0 ? JSON.stringify(newForm.ahcoThreeSign) : '';
                    newForm.ahcoSixSign = newForm.ahcoSixSign && newForm.ahcoSixSign.length > 0 ? JSON.stringify(newForm.ahcoSixSign) : '';
                    newForm.ahcoFiveSign = newForm.ahcoFiveSign && newForm.ahcoFiveSign.length > 0 ? JSON.stringify(newForm.ahcoFiveSign) : '';
                    addAjHostelCheckOutSystem(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "退房成功!",
                            });
                            this.partserch();
                            this.closeCheckOut();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleCheckOut(row) {
            this.form.ahaId = row.ahaId;
            this.isCheckOut = true;
        },
        removeAfter(file) {
            console.log(file,this.fileList);
            const url = this.form.ahcoTwoSign.findIndex(item => item === file)
            this.form.ahcoTwoSign.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            console.log(this.form.ahcoTwoSign, file);
            if (this.form.ahcoTwoSign && this.form.ahcoTwoSign.length > 0) {
                console.log(this.form.ahcoTwoSign, file);
                this.form.ahcoTwoSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            } else {
                this.$set(this.form, 'ahcoTwoSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        removeAfter2(file) {
            const url = this.form.ahcoThreeSign.findIndex(item => item === file)
            this.form.ahcoThreeSign.splice(url, 1)
        },
        // 上传图片
        fileChange2(file) {
            console.log(this.form.ahcoThreeSign, file);
            if (this.form.ahcoThreeSign && this.form.ahcoThreeSign.length > 0) {
                console.log(this.form.ahcoThreeSign, file);
                this.form.ahcoThreeSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList2.push(s)
                })
            } else {
                this.$set(this.form, 'ahcoThreeSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList2.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },

        removeAfter3(file) {
            const url = this.form.ahcoFiveSign.findIndex(item => item === file)
            this.form.ahcoFiveSign.splice(url, 1)
        },
        // 上传图片
        fileChange3(file) {
            console.log(this.form.ahcoFiveSign, file);
            if (this.form.ahcoFiveSign && this.form.ahcoFiveSign.length > 0) {
                console.log(this.form.ahcoFiveSign, file);
                this.form.ahcoFiveSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList3.push(s)
                })
            } else {
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList3.push(s)
                })
                this.$set(this.form, 'ahcoFiveSign', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        removeAfter4(file) {
            const url = this.form.ahcoSixSign.findIndex(item => item === file)
            this.form.ahcoSixSign.splice(url, 1)
        },
        // 上传图片
        fileChange4(file) {
            if (this.form.ahcoSixSign && this.form.ahcoSixSign.length > 0) {
               file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList4.push(s)
                })
                this.form.ahcoSixSign.push(...file)
            } else {
                this.$set(this.form, 'ahcoSixSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList4.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        handleRoomDetail(row) {
            getAjHostelBaseList({ ahbName: row.ahbName }).then((res) => {
                this.RoomDetail = res.data;
                this.isRoom = true;
            });
        },
        handleCheck(row) {
            getAjHostelBaseList({ pageSize: 0 }).then((res) => {
                this.statusAll = res.data;
                this.formCheck.ahaId = row.ahaId;
                this.dialogStatus = true;
            });
        },
        handleAddReturn(row) {
            this.form2 = {
                ahaId: row.ahaId,
            }
            this.diaAddReturn = true;
        },
        SureBtn2() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjAssetsFireEquipment(this.form2).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose2()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsKeyBorrowReturnReturn({ aakbrId: row.aakbrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch();
                            this.getDetailList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getDetail(row) {
            this.theRow = row;
            getAjAssetsKeyBorrowReturnList({ ahaId: row.ahaId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        getDetailList() {
            getAjAssetsKeyBorrowReturnList({ ahaId: this.theRow.ahaId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-assets-key/exportAjAssetsKey',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '入住申请.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsFireEquipment({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjHostelApplyCheck(this.formCheck).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.closeStatus()
                }
            })
        },
        closeStatus() {
            this.formCheck = {};
            this.dialogStatus = false;
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjAssetsFireEquipment({ ahaIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjAssetsFireEquipment({ ahaId: row.ahaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjAssetsFireEquipment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjHostelApplyDateCheckOut(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 关闭弹框
        handleClose2() {
            this.diaAddReturn = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ahaId = row.ahaId
                    console.log(jsonObj);
                    updateAjHostelApplyDateCheckOut(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
            // 日历缓存联动刷新：日历模式下操作成功（退房等）会走 partserch，同步刷新日历数据
            if (this.calendarLoaded) this.loadCalendarData(true);
        },
        getList() {
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
            // 日历缓存联动刷新：审核 / 修改预计退房时间等操作成功后走 getList，同步刷新日历数据
            if (this.calendarLoaded) this.loadCalendarData(true);
        },
        // ==================== 日历图模式 ====================
        // tab 切换：首次进入日历时拉取数据，之后使用缓存（操作成功后强制刷新）
        onTabClick() {
            if (this.activeTab === 'calendar') this.loadCalendarData(false);
        },
        // 拉取日历数据：申请中(1) + 已同意(2) 两次请求后前端合并
        // 后端 ahaStatus 为单值精确查询（不支持传 "1,2"）；pageSize 传 0 后端内部转 99999，即拉全量
        loadCalendarData(force) {
            if (this.calendarLoaded && !force) return;
            this.calLoading = true;
            Promise.all([
                getAjHostelApplyList({ ahaStatus: 1, currentPage: 1, pageSize: 0 }),
                getAjHostelApplyList({ ahaStatus: 2, currentPage: 1, pageSize: 0 }),
            ]).then(([res1, res2]) => {
                const list = [].concat(res1.data || [], res2.data || []);
                // 按入住时间升序排序：保证颜色分配顺序与格子内展示顺序稳定可复现
                list.sort((a, b) => (a.ahaUserDateCheckIn || '').localeCompare(b.ahaUserDateCheckIn || ''));
                this.calendarRecords = list;
                this.calendarLoaded = true;
                this.calLoading = false;
            }).catch(() => {
                this.calLoading = false;
            });
        },
        // 上一月（历史月份可无限回看）
        prevMonth() {
            const d = this.calMonthDate;
            this.calMonthDate = new Date(d.getFullYear(), d.getMonth() - 1, 1);
        },
        // 下一月：未来月份可自由查看（未来时段的入住/申请记录也能在日历上看到）
        nextMonth() {
            const d = this.calMonthDate;
            this.calMonthDate = new Date(d.getFullYear(), d.getMonth() + 1, 1);
        },
        // 月份选择器跳转：归一化到当月 1 号（历史与未来均不限制）
        onMonthPick(val) {
            if (!val) return;
            this.calMonthDate = new Date(val.getFullYear(), val.getMonth(), 1);
        },
        // 回到今天所在月份
        goToday() {
            const n = new Date();
            this.calMonthDate = new Date(n.getFullYear(), n.getMonth(), 1);
        },
        // 记录条样式：从 recordVisualMap（computed 预计算）查表，渲染时零重复计算
        chipStyle(item) {
            const v = this.recordVisualMap[item.rec.ahaId];
            return v ? v.style : {};
        },
        // 圆点色（悬浮卡片 / 折叠列表用）：同样查表
        dotColor(rec) {
            const v = this.recordVisualMap[rec.ahaId];
            return v ? v.dotColor : '#909399';
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

/* ==================== 日历图模式样式（dc- 前缀，与列表模式完全隔离） ==================== */
/* 模式切换 tab：紧凑化，避免挤压下方列表区域 */
.dc-tabs-wrap {
    width: 97%;
    margin: 6px auto 0;
    padding: 0 10px;
}
.dc-tabs-wrap .el-tabs__header {
    margin-bottom: 4px;
}
.dc-tabs-wrap .el-tabs__item {
    height: 36px;
    line-height: 36px;
}
.dc-calendar {
    /* 纵向 flex：工具栏/图例/表头固定高，网格区 flex:1 均分剩余高度，整月一屏呈现 */
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 6px 10px 10px; /* 压缩纵向 padding */
    overflow-y: auto; /* 兜底：极端小屏仍可滚动 */
}
/* 工具栏 */
.dc-toolbar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}
.dc-toolbar-left {
    display: flex;
    align-items: center;
}
/* 工具栏内相邻控件统一间距（date-picker 根类名不稳定，用通配相邻选择器） */
.dc-toolbar-left > * + * {
    margin-left: 8px;
}
.dc-toolbar-count {
    font-size: 12px;
    color: #909399;
    white-space: nowrap;
}
/* 图例：宿舍颜色对照 + 状态样式说明 */
.dc-legend {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 6px 14px;
    margin-bottom: 6px;
    padding: 4px 8px;
    background: #f7f8fa;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
}
.dc-legend-dorms {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 14px;
}
.dc-legend-item {
    display: inline-flex;
    align-items: center;
}
.dc-legend-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 4px;
    border-radius: 2px;
    flex-shrink: 0;
}
.dc-legend-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.dc-legend-chip {
    padding: 1px 8px;
    border-radius: 8px;
    line-height: 16px;
}
.dc-legend-chip--ok {
    background: hsl(210, 60%, 57%);
    color: #fff;
}
.dc-legend-chip--pending {
    border: 1px dashed hsl(210, 60%, 57%);
    background: repeating-linear-gradient(45deg, hsla(210, 60%, 66%, 0.15) 0px, hsla(210, 60%, 66%, 0.15) 5px, hsla(210, 60%, 66%, 0.4) 5px, hsla(210, 60%, 66%, 0.4) 10px);
    color: #3a6ea5;
}
.dc-legend-tip {
    color: #909399;
}
/* 周表头：周一 ~ 周日，周末微红 */
.dc-grid-head {
    flex-shrink: 0;
    display: flex;
}
.dc-head-cell {
    flex: 1;
    padding: 4px 0;
    text-align: center;
    font-weight: 600;
    color: #606266;
    background: #f2f6fc;
    border: 1px solid #ebeef5;
    border-left: 0;
}
.dc-head-cell:first-child {
    border-left: 1px solid #ebeef5;
}
.dc-head-cell--weekend {
    color: #f56c6c;
}
/* 月历网格：占满剩余高度，行高按剩余空间均分拉伸（一屏完整呈现整月） */
.dc-grid-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0; /* 允许收缩，不再固定最小高 */
    overflow: hidden;
}
.dc-grid-row {
    display: flex;
    flex: 1;
    min-height: 0; /* 允许行收缩到均分高度，不被格内记录条内容撑开（超出部分由格内滚动消化） */
}
.dc-cell {
    flex: 1;
    min-width: 0;
    min-height: 0; /* 去掉固定 min-height，格子高度随行均分 */
    display: flex;
    flex-direction: column; /* 日期行固定高度 + 记录条区占满剩余并独立滚动 */
    padding: 2px 3px;
    border: 1px solid #ebeef5;
    border-left: 0;
    border-top: 0;
}
.dc-grid-row:first-child .dc-cell {
    border-top: 1px solid #ebeef5;
}
.dc-cell:first-child {
    border-left: 1px solid #ebeef5;
}
/* 记录条区：超出格子高度时在格子内上下滑动查看（细滚动条，hover 时加深提示可滚） */
.dc-cell-items {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;          /* Firefox */
    scrollbar-color: #c0c4cc transparent;
}
.dc-cell-items::-webkit-scrollbar {
    width: 5px;
}
.dc-cell-items::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: #dcdfe6;
}
.dc-cell-items:hover::-webkit-scrollbar-thumb {
    background: #909399;
}
.dc-cell-items::-webkit-scrollbar-track {
    background: transparent;
}
.dc-cell--other .dc-daynum {
    color: #c0c4cc; /* 非当月补位日期置灰 */
}
.dc-cell--today {
    background: #f0f7ff; /* 今天整格淡蓝高亮 */
}
.dc-cell-date {
    height: 22px;
}
.dc-daynum {
    display: inline-block;
    min-width: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 13px;
    color: #606266;
}
.dc-daynum.is-weekend {
    color: #f56c6c; /* 周末轻微区分 */
}
.dc-daynum.is-today {
    background: #409eff;
    color: #fff;
    border-radius: 11px;
}
/* 记录条：悬浮上浮强调；详情与操作按钮在悬浮卡片（popover）中展示 */
.dc-chip {
    display: flex;
    align-items: center;
    height: 20px;
    margin: 1px 0;
    padding: 0 5px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    transition: box-shadow 0.15s, transform 0.15s;
}
.dc-chip:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    transform: translateY(-1px);
}
.dc-chip-name {
    overflow: hidden;
    text-overflow: ellipsis;
}
/* 「入」/「退」角标 */
.dc-badge {
    flex-shrink: 0;
    margin: 0 3px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    color: #fff;
    background: #409eff;
}
.dc-badge--out {
    background: #e6a23c;
}
/* 悬浮卡片（popover）内容 */
.dc-pop-title {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    font-weight: 600;
    color: #303133;
}
.dc-pop-row {
    font-size: 13px;
    line-height: 26px;
    color: #606266;
}
.dc-pop-actions {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #ebeef5;
}
.dc-empty {
    padding: 20px 0;
    text-align: center;
    color: #909399;
    font-size: 14px;
}
</style>